module.exports = __webpack_public_path__ + "20ee9bd18996dbf668b6585cf59a6bed.ttf";